import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOilskins = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 123.55 123.54",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		fill: "#231f20",
		children: [
			/* @__PURE__ */ _jsx("polygon", { points: "12.922 19.965 28.422 35.809 34.375 30.465 28.984 20.012" }),
			/* @__PURE__ */ _jsx("path", { d: "m82.797 64.348c2.93 0.805 6.078-0.852 6.914-3.828 0.805-2.93-0.906-6.008-3.859-6.836l-2.297-0.641-2.977 10.648 2.219 0.657z" }),
			/* @__PURE__ */ _jsx("path", { d: "m80.992 52.363l-18.555-5.227c-1.219-0.32-2.445 0.414-2.781 1.633l-1.742 6.203c-0.344 1.219 0.32 2.469 1.57 2.836l18.555 5.172 2.953-10.617z" }),
			/* @__PURE__ */ _jsx("path", { d: "m83.922 69.988c-1.414-1.344-3.172-2.414-5.227-2.977l-22.492-6.297-13.82-24.516c-0.727-1.266-1.898-2.273-3.414-2.688-3.031-0.852-6.18 0.93-7.008 3.961-0.414 1.438-0.219 2.906 0.438 4.148l17.289 30.32s1.414 2.273 4.977 3.445l31.43 8.812 14.578 14.797c0.484 0.508 1.117 0.898 1.875 1.117 2.195 0.609 4.492-0.703 5.133-2.875 0.414-1.539-0.078003-3.156-1.172-4.156l-22.587-23.091z" }),
			/* @__PURE__ */ _jsx("path", { d: "m100.7 76.113l3.266 4.273 6.641-7.25-5.609-3.125c0.531-3.93-1.906-7.734-5.812-8.836-4.297-1.195-8.766 1.297-9.961 5.594-1.219 4.32 1.297 8.766 5.594 9.961 2.045 0.586 4.124 0.266 5.881-0.617z" })
		]
	})]
});
const ForwardRef = forwardRef(SvgOilskins);
export { ForwardRef as ReactComponent };
